/**
 * Function to sanitize the title
 * Specifically replace the ® (Registered trademark symbol) with Superscript text <sup>
 *
 * @param {string} title - A string param to get the title string
 * @returns {string} - This returns sanitized title
 */
export const sanitizeTitle = (title: string) => {
  const sanitizeTitle = title.replace(/&reg;/gi, '<sup>&reg;</sup>').replace(/®/gi, '<sup>&reg;</sup>');
  return sanitizeTitle;
};